//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../Die/Die.DieAssistantFlangeProfileList.js";
import "../no/SelectPointList.js";
import "../no/SelectBody.js";
import "../Die/Die.DieAssistantTrimProfileList.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"Clearance",1,0],[1,"FlangeProfile",0,"ScCollector",0],[1,"FlangeProfileSet",0,"Die.DieAssistantFlangeProfileList",0],[0,"LowerBase",1,"Plane",0],[1,"PierceLocations",0,"SelectPointList",0],[1,"SheetMetal",0,"SelectBody",0],[0,"Thickness",1,0],[1,"TrimProfileSet",0,"Die.DieAssistantTrimProfileList",0],[0,"UpperBase",1,"Plane",0]],[[[],"NewTrimProfile",{R_:{trimProfile:"Die.DieAssistantTrimProfile"}},0,0],[[],"NewFlangeProfile",{R_:{flangeProfile:"Die.DieAssistantFlangeProfile"}},0,0],[[],"AutoGen",{},0,0],[[],"TrimSteelParms",{},0,0],[[],"FlangeSteelWipeParms",{},0,0],[[],"FlangeSteelRestrikeParms",{},0,0],[[],"UpperPadParms",{},0,0],[[],"LowerPostParms",{},0,0],[[],"LowerScrapCutterParms",{},0,0],[[],"LowerScrapCutterBaseParms",{},0,0]],[]];
SPLM.Die.TrimFlangeDieAssistantBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.TrimFlangeDieAssistantBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;